import React from 'react';
import story from '../img/story.png';

const Story = () => {
  return (
    <section className="story-section" id="story">
      <div className="story-container">
        <div className="story-content">
          <div className="story-header">
            <h2 className="story-title">StoryTelling of Memory Lamp</h2>
            <div className="story-divider"></div>
          </div>
          
          <div className="story-text">
            <p className="story-quote">
              "Có những ký ức ta không thể giữ bằng lời nói hay hình ảnh — chỉ có ánh sáng mới gợi lại được cảm giác ấy."
            </p>
            
            <div className="story-paragraphs">
              <p>
                Memory Lamp được tạo ra như một người bạn của ký ức, khi ánh sáng ấm áp lan tỏa, 
                những kỷ niệm tưởng chừng đã phai mờ lại trở nên rõ ràng hơn.
              </p>
              
              <p>
                Mỗi lần thắp sáng đèn, không chỉ là chiếu sáng căn phòng, mà là thắp lên cảm xúc, 
                là khoảnh khắc trở về với những điều thân thuộc, với người thân, với quê hương.
              </p>
              
              <p className="story-conclusion">
                Memory Lamp không chỉ là một chiếc đèn — nó là ký ức được thắp sáng.
              </p>
            </div>
          </div>
          
          {/* <div className="story-visual">
            <div className="lamp-illustration">
              <div className="lamp-base"></div>
              <div className="lamp-shade"></div>
              <div className="light-rays">
                <div className="ray ray-1"></div>
                <div className="ray ray-2"></div>
                <div className="ray ray-3"></div>
                <div className="ray ray-4"></div>
              </div>
            </div>
          </div> */}
          <div className="story-visual">
            <img src={story} alt="Memory Lamp" className="story-image" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Story;
